import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloContacto from '../components/sections/Contacto/TituloContacto'; 
import DireccionFormulario from '../components/sections/Contacto/DireccionFormulario';
import TituloGracias from '../components/sections/Gracias/TituloGracias';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const ContactoDecototal = () => {
  return (
    <div>
      <SeoMetadata
        title="Contacto | Decototal"
        description="Contacta a Decototal para cotizar pisos, recubrimientos y materiales para tus proyectos. Nuestro equipo te brinda asesoría personalizada."
        keywords="contacto Decototal, cotizar pisos, cotización de recubrimientos, asesoría de materiales"
        path="/contacto-decototal"
        image="/assets/img/contacto/banner-contacto.jpg"
      />

      <Header />
        <TituloContacto /> 
        <DireccionFormulario /> 
        <TituloGracias /> 
      <Footer />
    </div>
  );
};

export default ContactoDecototal;